module.exports = __webpack_public_path__ + "d3aa0fdaf4f66919b787eb065fe17e05.png";